import * as React from "react";
import { Input } from "components/bootstrap";
const IlluminateCacheFieldSet = ({ config }, ref) => /* @__PURE__ */ React.createElement("fieldset", { ref }, /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "text",
    name: "max_size",
    value: config.max_size,
    label: "Maximum entries",
    labelClassName: "col-sm-3",
    wrapperClassName: "col-sm-9",
    disabled: true
  }
), /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "text",
    name: "expire_after_access",
    value: `${config.expire_after_access} ${config.expire_after_access_unit}`,
    label: "Expire after access",
    labelClassName: "col-sm-3",
    wrapperClassName: "col-sm-9",
    disabled: true
  }
), /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "text",
    name: "expire_after_write",
    value: `${config.expire_after_write} ${config.expire_after_write}`,
    label: "Expire after write",
    labelClassName: "col-sm-3",
    wrapperClassName: "col-sm-9",
    disabled: true
  }
), /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "checkbox",
    id: "ignore_null",
    name: "ignore_null",
    label: "Ignore empty results",
    checked: config.ignore_null,
    wrapperClassName: "col-md-offset-3 col-md-9",
    disabled: true
  }
), /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "text",
    name: "ttl_empty_unit",
    value: `${config.ttl_empty} ${config.ttl_empty_unit}`,
    label: "TTL for empty results",
    labelClassName: "col-sm-3",
    wrapperClassName: "col-sm-9",
    disabled: true
  }
));
export default IlluminateCacheFieldSet;
